[
	{
		"type": "header",
		"id": "general",
		"title": "General Settings",
		"options": [
			{
				"id": "animation",
				"type": "radio",
				"title": "Start Animation",
				"description": "Enable/Disable starting animation",
				"options": [
					{
						"value": "true",
						"title": "True"
					},
					{
						"value": "false",
						"title": "False"
					}
				],
				"default": "true",
				"onlyIndex": true
			},
			{
				"id": "presentationMode",
				"type": "radio",
				"title": "Presentation Mode",
				"description": "When activated, the presentation mode disables most of the hover events which then require a click in order to be triggered",
				"options": [
					{
						"value": "true",
						"title": "True"
					},
					{
						"value": "false",
						"title": "False"
					}
				],
				"default": "false"
			}
		]
	},
	{
		"id": "charts",
		"type": "header",
		"title": "Charts Settings",
		"options": [
			{
				"id": "lineType",
				"type": "radio",
				"title": "Line Type",
				"description": "Type of line used in time-series charts",
				"options": [
					{
						"value": "spline",
						"title": "Spline"
					},
					{
						"value": "line",
						"title": "Line"
					}
				],
				"default": "spline",
				"skipIndex": true
			},
			{
				"id": "lineWidthFactor",
				"type": "range",
				"title": "Line Width",
				"description": "Set line width (default: 1)",
				"options": [
					{
						"value": "0.75",
						"title": "Min"
					},
					{
						"value": "3",
						"title": "Max"
					},
					{
						"value": "0.25",
						"title": "Step"
					}
				],
				"default": 1,
				"skipIndex": true,
				"enabled": true
			},
			{
				"id": "markerThreshold",
				"type": "range",
				"title": "Marker Threshold",
				"description": "Set distance allowed between two markers before hiding them. Set to 0 to show all markers (default: 2)",
				"options": [
					{
						"value": "0",
						"title": "Min"
					},
					{
						"value": "4",
						"title": "Max"
					},
					{
						"value": "1",
						"title": "Step"
					}
				],
				"default": 2,
				"skipIndex": true,
				"enabled": true
			},
			{
				"id": "verticalGridLines",
				"type": "radio",
				"title": "Vertical Grid Lines",
				"description": "Vertical grid lines in time series",
				"options": [
					{
						"value": "true",
						"title": "True"
					},
					{
						"value": "false",
						"title": "False"
					}
				],
				"default": "false",
				"skipIndex": true
			},
			{
				"id": "regionalStatisticsSingleModelColor",
				"type": "radio",
				"title": "Regional Statistics Colors",
				"description": "Regional statistics colors charts (evaluation and inter-comparison pages)",
				"options": [
					{
						"value": "theme",
						"title": "Theme"
					},
					{
						"value": "value",
						"title": "Value"
					}
				],
				"default": "theme",
				"skipIndex": true
			}
		]
	},
	{
		"id": "other",
		"type": "header",
		"title": "Other Settings",
		"options": [
			{
				"id": "showEmptyRegions",
				"type": "radio",
				"title": "Show Empty Regions (regional statistics)",
				"description": "Show empty regions in regional statistics",
				"options": [
					{
						"value": "true",
						"title": "True"
					},
					{
						"value": "false",
						"title": "False"
					}
				],
				"default": "true"
			},
			{
				"id": "showProxyVariables",
				"type": "radio",
				"title": "Show Proxy Variables (time series)",
				"description": "Show proxy variables observations in time series",
				"options": [
					{
						"value": "true",
						"title": "True"
					},
					{
						"value": "false",
						"title": "False"
					}
				],
				"default": "false"
			},
			{
				"id": "showIndividualModels",
				"type": "radio",
				"title": "Show Individual Models (intercomparison)",
				"description": "Show individual models in intercomparison page",
				"options": [
					{
						"value": "true",
						"title": "True"
					},
					{
						"value": "false",
						"title": "False"
					}
				],
				"default": "false"
			},
			{
				"id": "zoomOnSelectedRegion",
				"type": "radio",
				"title": "Zoom On Selected Region",
				"description": "Zoom on the selected region",
				"options": [
					{
						"value": "true",
						"title": "True"
					},
					{
						"value": "false",
						"title": "False"
					}
				],
				"default": "false"
			},
			{
				"id": "zoomOnSelectedSeason",
				"type": "radio",
				"title": "Zoom On Selected Season (single year)",
				"description": "Zoom on the selected season",
				"options": [
					{
						"value": "true",
						"title": "True"
					},
					{
						"value": "false",
						"title": "False"
					}
				],
				"default": "false"
			}
		]
	}
]